import { PRODUCT_SPECIFIC_TYPE } from '@tt4b/ttam-enums';
import { trackEvent } from '@tt4b/ttam-utils';

const productTypeMap = {
  [PRODUCT_SPECIFIC_TYPE.ALL]: 'All products',
  [PRODUCT_SPECIFIC_TYPE.PRODUCT_SET]: 'Product set',
  [PRODUCT_SPECIFIC_TYPE.PRODUCTS]: 'Add products',
};

// 编辑场景下选择一个product type
export function productTypeEditClick(productType: PRODUCT_SPECIFIC_TYPE) {
  trackEvent('module_ad_creative_nonshop_product_type_edit_click', {
    product_type: productTypeMap[productType],
  });
}

// 编辑场景下点击 product set dropdown list
export function productSetDropdownEditClick() {
  trackEvent('module_ad_creative_nonshop_product_type_edit_click');
}

// 编辑场景下在product set dropdown list选择一个pset
export function productSetEditChoose() {
  trackEvent('module_ad_creative_nonshop_product_set_edit_choose');
}

// 编辑场景下 toggle on/off dynamic destination
export function dynamicDestinationEditClick(isOn: boolean) {
  trackEvent('module_ad_creative_dynamic_destination_edit_click', {
    on_off: isOn ? 'on' : 'off',
  });
}

// 编辑场景下点击删除add-on
export function deleteAddOnClick() {
  trackEvent('edit_ad_delete_add_on_click');
}

// 编辑场景下点击删除add-on时点击确认
export function addOnDeleteConfirm() {
  trackEvent('edit_creative_add_on_delete_confirm');
}

// 编辑场景下点击删除add-on时点击取消
export function addOnDeleteCancel() {
  trackEvent('edit_creative_add_on_delete_cancel');
}
